import css from "./Badge.module.css";

export function HarborBage() {
  return (
    <div className={css.root}>
      <div className={css.harbor}>
        <img src="/s/harbor_icon.png" alt="Harbor Icon" />
        <div>Harbor</div>
      </div>
    </div>
  );
}
